<rid-map-label [name]="comp().location.name" [dots]="stopDots()" [state]="labelState()" [pulsing]="hasWorkToday()" />
